module.exports = __webpack_public_path__ + "img/palace_hotel_thumbnail.aadde692.jpg";